var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaffDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "79px",
    height: "79px",
    viewBox: "0 0 79 79",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B546A89E-7159-4E8F-B737-4D33CB9D1E9A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 79,
    height: 79,
    rx: 39.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "200617_staff_listing",
    transform: "translate(-907.000000, -603.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10-Copy-5",
    transform: "translate(814.000000, 563.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bitmap",
    transform: "translate(93.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#CAD3C0",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,16 C31.8202444,16 26,21.8203167 26,29 C26,36.1796833 31.8202444,42 39,42 C46.1797556,42 52,36.1796833 52,29 C52,21.8203167 46.1797556,16 39,16 Z M39.5,49 C24.2649997,49 12,61.1057143 12,76.1428571 L12,79 L67,79 L67,76.1428571 C67,61.1057143 54.7349989,49 39.5,49 Z",
    id: "Shape",
    fill: "#E0EAD5",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffDefault);
export default __webpack_public_path__ + "static/media/staff-default.5f72f124f6d12842f97c357d716d30ad.svg";
export { ForwardRef as ReactComponent };